import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";

const AppContext = createContext();

const AppContextProvider = ({ children }) => {
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [dropdownContent, setDropdownContent] = useState(null);
  const [activeLink, setActiveLink] = useState("/");
  const [navLinks, setNavLinks] = useState([]);
  const [lang, setLang] = useState("en");
  const { t } = useTranslation();

  useMemo(() => {
    const links = [
      { name: t("navbar.home"), to: "/" },
      { name: t("navbar.features"), to: "/features" },
      { name: t("navbar.whyUs"), to: "/whyus" },
      { name: t("navbar.faq"), to: "/faq" },
    ];
    setNavLinks(links);
  }, [lang]);

  const toggledropdown = (dropdownType) => {
    setIsDropdownOpen(true);
    setDropdownContent(dropdownType);
  };

  const handleCloseDropdown = () => {
    setIsDropdownOpen(false);
    setDropdownContent(null);
    setActiveLink("/");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isDropdownOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isDropdownOpen]);

  return (
    <AppContext.Provider
      value={{
        handleCloseDropdown,
        toggledropdown,
        isDropdownOpen,
        dropdownContent,
        activeLink,
        setActiveLink,
        dropdownRef,
        setIsDropdownOpen,
        setDropdownContent,
        navLinks,
        setNavLinks,
        lang,
        setLang,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContextProvider;

export const useAppState = () => useContext(AppContext);
